import React, { useState,useContext,useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { AuthContext } from 'src/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Page from 'src/components/Page';
import { useFirestore } from 'reactfire';
import { doc,getDoc,setDoc,deleteDoc } from 'firebase/firestore'; 
import { useAlertContext } from 'src/context/AlertContext';


import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

function getSteps() {
  return ['Tell us your name', 'Connect your telegram', 'Ready to go'];
}

export default function HorizontalLabelPositionBelowStepper() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const canSkip = false;
  const [name, setName] = useState(null);

  const {useErrorAlert, useAlert} = useAlertContext();

  const [telegramDetail, setTelegramDetail] = useState(null);

  const steps = getSteps();

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };
  const {user} = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (!(!!user && !user.name)) {
      navigate('/');
    }

  }, [user]);
  function getStepContent(stepIndex) {
    switch (stepIndex) {
    case 0:
      return <Step1 handleNext={handleNext} setName={setName} name={name} />;
    case 1:
      return (
        <Step2
          telegramCodeExist={telegramCodeExist}
        />
      );
    case 2:
      return <Step3 />;
    default:
      return 'Unknown stepIndex';
    }
  }
  const db = useFirestore();


  const handleReset = () => {
    setActiveStep(0);
  };
  const verifyInvitationLink = async() =>{
    console.log('name',name);

    if(name ===undefined){

      useAlert('invitation code should not be empty','warning');
    }
    else {
      const docSnap= await getDoc(doc(db, 'users',name));
      if (docSnap.exists()) {
        if (doc && docSnap.data().newUser ===name) {
          handleNext();
        } else {
          useAlert('Invitation code doesn\'t exist','warning');
        }
      } else {
        useAlert('Invitation code doesn\'t exist','warning');
      }
    
    }
   
  };

  const telegramCodeExist = async(telegramId)=>{
    const docSnap= await getDoc(doc(db, 'users',name));

    if (docSnap.exists()) {
      if (doc && docSnap.data().newUser ===name) {
        const id = user.userId;
        let newData = {...docSnap.data(),id, telegramId};
        delete newData.newUser;

        setDoc(doc(db, 'users', id), newData)
          .then(()=>{
            deleteDoc(doc(db, 'users', docSnap.id))
              .catch((err)=>{
                useErrorAlert('Can`t register user',err);
              });
         
          })
          .catch((err)=>{
            useErrorAlert('Can`t register user',err);
          });
       
      } else {
        useAlert('Invitation code doesn\'t exist','warning');
      }
    } else {
      useAlert('Invitation code doesn\'t exist','warning');
    }
   
  };
  return (
    <Page title="Register">
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Container>
          {activeStep === steps.length ? (
            <div>
              <Typography className={classes.instructions}>
              All steps completed
              </Typography>
              <Button onClick={handleReset}>Reset</Button>
            </div>
          ) : (
            <div>
              <Typography className={classes.instructions}>
                {getStepContent(activeStep)}
              </Typography>
              <div>
                {activeStep !== 2 && (
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.backButton}
                  >
                  Back
                  </Button>
                )}

                {activeStep === 0 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={verifyInvitationLink}
                    disabled={name === null}
                  >
                  Verify
                  </Button>
                )}
                {activeStep === 1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={telegramCodeExist}
                    disabled={!canSkip}
                  >
                    {/* {canSkip?"Skip": <Countdown date={Date.now() + 3000} renderer={countDown} />} */}
                  Next
                  </Button>
                )}
              </div>
            </div>
          )}
        </Container>
      </div>
    </Page>
  );
}
